module.exports = __webpack_public_path__ + "static/Calibre-RegularItalic-35657aa2d12ff78e3d8a8a5ba28c2c35.woff2";